import React from 'react';
import './BorderedSec.css'

const BorderedSec = ({children,className,...rest}) => {
  return (
    <div className={`borderedsec ${className}`} {...rest}>{children}</div>
  )
}

export default BorderedSec